export default __webpack_public_path__ + "static/media/nuxtJS.81cb52af.svg";